<section>

  <h1>{{ 'pages.user-parking.prepaidTotal' | translate}}</h1>

  <div class='addCredit-input'>
    <div>
      <label for='prepaid-amount'>{{ 'pages.user-parking.availablePrepaid' | translate}}</label>
      <input id='prepaid-amount' type='text' disabled [value]='prepaid'>
    </div>
  </div>

  <h1>{{ 'pages.user-parking.addCredit' | translate}}</h1>




  <div class='addCredit-input'>
   <div>
    <label for='credit-input'>{{ 'pages.user-parking.ammount' | translate}}</label>
    <input type="number" step="any"[(ngModel)]='addedAmount' id='credit-input' min='0'>
   </div>
    <button (click)='addParking()'  class='bciti-button--blue bciti-button'>{{ 'pages.user-parking.addButton' | translate}}</button>
  </div>

  <div class='transaction-history'>
    <p>{{'pages.user-parking.TransactionHistory' | translate}}</p>

    <table >
      <tr *ngFor='let parking of history'> <td>{{parking.date}}</td> <td>{{parking.price}}</td></tr>
    </table>
  </div>


</section>
